<template >
  <div class="body">
    <el-container>
      <left-meun ref="_leftMeun" @initData="initData"></left-meun>
      <el-container>
        <el-header class="header">
          <span>
            <el-breadcrumb class="left" separator="/">
              <el-breadcrumb-item>
                <a href="#">首页</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="#">数据管理</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>
                <a href="#/data/users">校友信息查询</a>
              </el-breadcrumb-item>
              <el-breadcrumb-item>编辑校友</el-breadcrumb-item>
            </el-breadcrumb>
          </span>
          <head-right></head-right>
        </el-header>
        <el-main class="main">
          <div class="mainTitle">
            <h3>编辑校友</h3>
            <p>手动编辑校友</p>
          </div>
          <div class="main_info">
            <div class="basicInformation">
              <div class="basicInformationText">基础信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <div class="mainInfoLeft">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>学号</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.student_no" placeholder="请填写学号" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>英文姓名</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.name_en" placeholder="请填写英文姓名" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>出生日期</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.date_of_birth" placeholder="请填写出生日期" size="small" class="input_style"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>国家地区</div>
                </div>

                <el-input :disabled="true" v-model="ais_info.region" placeholder="请填写国家地区" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoMiddle">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>中文姓名</div>
                </div>

                <el-input :disabled="true" v-model="ais_info.name_cn" placeholder="请填写中文姓名" style="margin: 6px 0px 0px 20px; width: 95%" size="small"></el-input>

                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>性别</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.gender" placeholder="请填写性别" style="margin: 6px 0px 0px 20px; width: 95%" size="small"></el-input>

                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>身份证号</div>
                </div>

                <el-input :disabled="true" v-model="ais_info.id_card_number" placeholder="请填写身份证号" style="margin: 6px 0px 0px 20px; width: 95%" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoRight">
              <div class="mainInfoPhotoTittle">
                <div class="mainInfoPhotoTittleText">相片</div>
                <el-image class="mainInfoPhoto" :src="aisPhotoUrl" fit="cover"></el-image>
              </div>
            </div>
          </div>
          <div class="main_info" style="height: 322px">
            <div class="basicInformation" style="width: 108px">
              <div class="basicInformationText">基础教育信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <div class="mainInfoLeft" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" :model="ais_info" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>专业</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.programme" placeholder="请填写专业" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>招生类型</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.admission_category" placeholder="请填写招生类型" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>荣誉分类</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.honours_classification" placeholder="请填写荣誉分类" size="small" class="input_style"></el-input>
              </el-form>
            </div>
            <div class="mainInfoMiddle" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" :model="ais_info" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>学部</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.division" placeholder="请填写学部" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>入学年份</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.year" placeholder="请填写入学年份" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoRight" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" :model="ais_info" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>目前工作状态</div>
                </div>
                <el-select class="input_style" v-model="ais_info.status" size="small" placeholder="请选择填写状态">
                  <el-option v-for="item in aisInfoStatusOptions" :key="item" :value="item"></el-option>
                </el-select>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>毕业年份</div>
                </div>
                <el-input :disabled="true" v-model="ais_info.graduation_year" placeholder="请填写毕业年份" class="input_style" size="small"></el-input>
              </el-form>
            </div>
          </div>
          <div class="main_info" style="height: 260px">
            <div class="basicInformation" style="width: 108px">
              <div class="basicInformationText">联系方式</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <div class="mainInfoLeft" style="height: 209px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>微信</div>
                </div>
                <el-input v-model="ais_info.wechat" placeholder="请填写微信" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>联系电话</div>
                </div>
                <el-input v-model="ais_info.mobile_phone" placeholder="请填写联系电话" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoMiddle" style="height: 209px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>校友邮箱</div>
                </div>
                <el-input v-model="ais_info.alumni_email" placeholder="请填写校友邮箱" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoRight" style="height: 209px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>常用邮箱</div>
                </div>
                <el-input v-model="ais_info.active_email" placeholder="请填写常用邮箱" class="input_style" size="small"></el-input>
              </el-form>
            </div>
          </div>

          <div class="increasedDiv" style="height: auto">
            <div class="basicInformation">
              <div class="basicInformationText">深造信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <template>
              <el-table :data="ais_education" style="width: 100%">
                <el-table-column prop="education_status" label="*深造状态" min-width="1" align="left"></el-table-column>
                <el-table-column prop="education_city" label="*所在地" min-width="1" align="left"></el-table-column>
                <el-table-column prop="education_school" label="*院校名称" min-width="1" align="left"></el-table-column>
                <el-table-column prop="education_programme" label="*专业" min-width="1" align="left"></el-table-column>
                <el-table-column prop="education_graduation_year" label="*毕业年份" min-width="1" align="left"></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="1" align="left">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editEducation(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteEducation(scope.$index, ais_education)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="footer">
                <div class="bor">
                  <el-button @click="addEducation()" type="text" class="addData_style">+新增深造信息</el-button>
                </div>
              </span>
            </template>
          </div>
          <div class="increasedDiv" style="height: auto">
            <div class="basicInformation">
              <div class="basicInformationText">工作信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <template>
              <el-table :data="ais_job_info" style="width: 100%">
                <el-table-column prop="status" label="*工作状态" min-width="1"></el-table-column>
                <el-table-column prop="unit_property" label="*单位性质" min-width="1"></el-table-column>
                <el-table-column prop="job_type" label="*行业类型" min-width="1"></el-table-column>
                <el-table-column prop="position" label="*工作职位" min-width="1"></el-table-column>
                <el-table-column prop="pay" label="*薪酬范围" min-width="1"></el-table-column>
                <el-table-column prop="organization_city" label="所在地" min-width="1"></el-table-column>
                <el-table-column prop="organization" label="单位名称" min-width="1"></el-table-column>
                <el-table-column prop="registered_address" label="公司注册地" min-width="1"></el-table-column>
                <el-table-column prop="employees" label="雇员人数" min-width="1"></el-table-column>
                <el-table-column prop="turnover" label="年营业额" min-width="1"></el-table-column>
                <el-table-column prop="freelance" label="从事何种自由职业" min-width="2"></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="2" align="left">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editJobInfo(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteJobInfo(scope.$index, ais_job_info)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="footer">
                <div class="bor">
                  <el-button @click="addJobInfo()" type="text" class="addData_style">+新增个人工作信息</el-button>
                </div>
              </span>
            </template>
          </div>
          <div class="main_info" style="height: 460px">
            <div class="basicInformation" style="width: 72px">
              <div class="basicInformationText">家庭信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <div class="mainInfoLeft" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>所在省份</div>
                </div>
                <el-input v-model="ais_info.family_province" placeholder="请填写所在省份" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>父亲姓名</div>
                </div>
                <el-input v-model="ais_info.father_name" placeholder="请填写父亲姓名" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>父亲职位</div>
                </div>
                <el-input v-model="ais_info.father_position" placeholder="请填写父亲职位" size="small" class="input_style"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>母亲姓名</div>
                </div>
                <el-input v-model="ais_info.mother_name" placeholder="请填写母亲姓名" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>母亲职位</div>
                </div>
                <el-input v-model="ais_info.mother_position" placeholder="请填写母亲职位" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoMiddle" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>城市</div>
                </div>
                <el-input v-model="ais_info.family_city" placeholder="请填写城市" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>父亲联系方式</div>
                </div>
                <el-input v-model="ais_info.father_contact_number" placeholder="请填写父亲联系方式" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle" style="margin-top: 98px">
                  <div class="mainInfoTittleText"><font color="red">*</font>母亲联系方式</div>
                </div>
                <el-input v-model="ais_info.mother_contact_number" placeholder="请填写母亲联系方式" class="input_style" size="small"></el-input>
              </el-form>
            </div>
            <div class="mainInfoRight" style="height: 271px">
              <el-form :label-position="labelPosition" label-width="80px" size="small">
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>家庭地址</div>
                </div>
                <el-input v-model="ais_info.family_address" placeholder="请填写家庭地址" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle">
                  <div class="mainInfoTittleText"><font color="red">*</font>父亲单位</div>
                </div>
                <el-input v-model="ais_info.father_employment" placeholder="请填写父亲单位" class="input_style" size="small"></el-input>
                <div class="mainInfoTittle" style="margin-top: 98px">
                  <div class="mainInfoTittleText"><font color="red">*</font>母亲单位</div>
                </div>
                <el-input v-model="ais_info.mother_employment" placeholder="请填写母亲单位" class="input_style" size="small"></el-input>
              </el-form>
            </div>
          </div>
          <div class="increasedDiv" style="height: auto">
            <div class="basicInformation">
              <div class="basicInformationText">捐助信息</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <template>
              <el-table :data="ais_journal" style="width: 100%">
                <el-table-column prop="journal_time" label="*捐助时间" min-width="1" align="left"></el-table-column>
                <el-table-column prop="content" label="*捐助内容" min-width="1" align="left"></el-table-column>
                <el-table-column prop="money" label="捐助金额" min-width="1" align="left"></el-table-column>
                <el-table-column prop="type" label="捐助类型" min-width="1" align="left"></el-table-column>
                <el-table-column prop="remark" label="备注" min-width="1" align="left"></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="1" align="left">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editJournal(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteJournal(scope.$index, ais_journal)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="footer">
                <div class="bor">
                  <el-button @click="addJournal()" type="text" class="addData_style">+新增捐助信息</el-button>
                </div>
              </span>
            </template>
          </div>
          <div class="increasedDiv" style="height: auto">
            <div class="basicInformation" style="width: auto">
              <div class="basicInformationText">荣誉信息（在校期间所获奖学金及其他荣誉信息；毕业后所获荣誉信息）</div>
            </div>
            <el-divider></el-divider>
            <div class="grayLine"></div>
            <template>
              <el-table :data="ais_honor" style="width: 100%">
                <el-table-column prop="honor_time" label="*荣誉时间" min-width="1" align="left"></el-table-column>
                <el-table-column prop="content" label="*荣誉内容" min-width="1" align="left"></el-table-column>
                <el-table-column prop="operating" label="操作" min-width="1" align="left">
                  <template slot-scope="scope">
                    <el-button size="mini" @click="editHonor(scope.$index, scope.row)">编辑</el-button>
                    <el-button size="mini" type="danger" @click="deleteHonor(scope.$index, ais_honor)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <span slot="footer">
                <div class="bor">
                  <el-button @click="addHonor()" type="text" class="addData_style">+新增荣誉信息</el-button>
                </div>
              </span>
            </template>
          </div>

          <div class="foot">
            <el-button style="float: right" size="small" type="primary" @click="saveEdit()">提交</el-button>
            <el-button style="float: right; margin-right: 15px" size="small" @click="toOpLog()">操作日志</el-button>
          </div>
        </el-main>
        <add-edit-edu-dialog ref="_addEditEduDialog" @toSave="$toSaveEdit"></add-edit-edu-dialog>
        <add-edit-job-dialog ref="_addEditJobDialog" @toSave="$toSaveEdit"></add-edit-job-dialog>
        <add-edit-journal-dialog ref="_addEditJournalDialog" @toSave="$toSaveEdit"></add-edit-journal-dialog>
        <add-edit-honor-dialog ref="_addEditHonorDialog" @toSave="$toSaveEdit"></add-edit-honor-dialog>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import * as StrUtils from '@/utils/strUtils.js'
import * as Constant from '@/utils/constant.js'
import { URL_PATH } from '@/config/config'
import leftMeun from '@/components/layout/leftMeun'
import headRight from '@/components/layout/headRight'
import addEditInfoDialog from '@/components/dialog/addEditInfoDialog'
import addEditEduDialog from '@/components/dialog/addEditEduDialog'
import addEditJobDialog from '@/components/dialog/addEditJobDialog'
import addEditJournalDialog from '@/components/dialog/addEditJournalDialog'
import addEditHonorDialog from '@/components/dialog/addEditHonorDialog'

var userid
var del_ais_education = []
var del_ais_job_info = []
var del_ais_journal = []
var del_ais_honor = []

export default {
  components: {
    leftMeun,
    headRight,
    addEditEduDialog,
    addEditJobDialog,
    addEditJournalDialog,
    addEditHonorDialog
  },
  data() {
    return {
      meunItem: null,
      meunTitle: '',
      URL_PATH: URL_PATH,
      // editToken: "", //编辑用户信息的token
      aisPhotoUrl: '',
      ais_info: {}, //个人信息
      ais_education: [], //深造信息
      ais_job_info: [], // 工作列表
      ais_journal: [], //捐助信息
      ais_honor: [], //荣誉信息
      labelPosition: 'top',
      aisInfoStatusOptions: Constant.work_status_options
    }
  },
  created() {
    userid = this.$route.query.userid
    this.getInfo()
  },
  methods: {
    initData(meunItem) {
      this.meunItem = meunItem
      this.meunTitle = this.meunItem.name
    },
    // 编辑
    saveEdit() {
      if (
        this.ais_info.wechat == '' ||
        this.ais_info.wechat == null ||
        this.ais_info.alumni_email == '' ||
        this.ais_info.alumni_email == null ||
        this.ais_info.active_email == '' ||
        this.ais_info.active_email == null ||
        this.ais_info.mobile_phone == '' ||
        this.ais_info.mobile_phone == null ||
        this.ais_info.family_province == '' ||
        this.ais_info.family_province == null ||
        this.ais_info.family_city == '' ||
        this.ais_info.family_city == null ||
        this.ais_info.family_address == '' ||
        this.ais_info.family_address == null ||
        this.ais_info.father_name == '' ||
        this.ais_info.father_name == null ||
        this.ais_info.father_position == '' ||
        this.ais_info.father_position == null ||
        this.ais_info.father_contact_number == '' ||
        this.ais_info.father_contact_number == null ||
        this.ais_info.father_employment == '' ||
        this.ais_info.father_employment == null ||
        this.ais_info.mother_name == '' ||
        this.ais_info.mother_name == null ||
        this.ais_info.mother_position == '' ||
        this.ais_info.mother_position == null ||
        this.ais_info.mother_contact_number == '' ||
        this.ais_info.mother_contact_number == null ||
        this.ais_info.mother_employment == '' ||
        this.ais_info.mother_employment == null
      ) {
        this.$message.error('请完善必填项再提交')
        return
      }
      if (this.ais_info.wechat.length < 6 || this.ais_info.wechat.length > 20) {
        this.$message.error('微信限制6-20个字符')
        return
      }
      this.putDelAisInfo()
      this.$api
        .updateAisById({
          token: localStorage.getItem('token'),
          id: this.ais_info.id,
          ais_info: JSON.stringify(this.ais_info),
          ais_education: JSON.stringify(this.ais_education),
          ais_job_info: JSON.stringify(this.ais_job_info),
          ais_journal: JSON.stringify(this.ais_journal),
          ais_honor: JSON.stringify(this.ais_honor)
          // photo: photo
        })
        .then(({ data }) => {
          if (data.Code != 0) {
            this.$message.error(data.Msg)
          } else {
            this.$router.go(0)
          }
        })
        .catch(({ error }) => {
          // this.$message.error(error);
        })
    },
    // 添加已清除的数据到列表
    putDelAisInfo() {
      if (del_ais_education.length > 0) {
        del_ais_education.forEach(element => {
          this.ais_education.push(element)
        })
        del_ais_education = []
      }
      if (del_ais_job_info.length > 0) {
        del_ais_job_info.forEach(element => {
          this.ais_job_info.push(element)
        })
        del_ais_job_info = []
      }
      if (del_ais_journal.length > 0) {
        del_ais_journal.forEach(element => {
          this.ais_journal.push(element)
        })
        del_ais_journal = []
      }
      if (del_ais_honor.length > 0) {
        del_ais_honor.forEach(element => {
          this.ais_honor.push(element)
        })
        del_ais_honor = []
      }
    },
    // 获取基础信息
    getAisInfoById: function () {
      this.$api
        .getAisInfoById({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          this.ais_info = data.Data
          this.ais_info.gender = StrUtils.gender(this.ais_info.gender)
        })
        .catch(({ error }) => {
          this.$message.error(error)
        })
    },
    // 获取校友头像
    getAisPhoto: function () {
      this.$api
        .getAishoto({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          // console.log(data);
          this.aisPhotoUrl = this.URL_PATH + data.Data.photo
        })
        .catch(({ error }) => {})
    },
    // 获取工作信息
    getAisJobInfoById: function () {
      this.$api
        .getAisJobInfoById({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          // console.log(data);
          // 获取校友工作信息列表
          this.ais_job_info = data.Data
        })
        .catch(({ error }) => {})
    },
    // 获取深造信息
    getAisEducationById: function () {
      this.$api
        .getAisEducationById({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          this.ais_education = data.Data
        })
        .catch(({ error }) => {})
    },
    // 获取捐助信息
    getAisJournalById: function () {
      this.$api
        .getAisJournalById({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          this.ais_journal = data.Data
        })
        .catch(({ error }) => {})
    },
    // 获取荣誉信息
    getAisHonorById: function () {
      this.$api
        .getAisHonorById({
          token: localStorage.getItem('token'),
          id: userid
        })
        .then(({ data }) => {
          this.ais_honor = data.Data
          // console.log(data);
        })
        .catch(({ error }) => {})
    },
    // getEditToken() {
    //   this.$api
    //     .getEditToken({
    //       token: localStorage.getItem("token"),
    //     })
    //     .then(({ data }) => {
    //       // console.log(data);
    //       this.editToken = data.Data.editToken;
    //     })
    //     .catch(({ error }) => {});
    // },
    getInfo: function () {
      this.getAisInfoById()
      this.getAisPhoto()
      this.getAisJobInfoById()
      this.getAisEducationById()
      this.getAisJournalById()
      this.getAisHonorById()
      // this.getEditToken();
    },
    // 编辑深造信息
    editEducation(index, info) {
      this.addEducation(index, info)
    },
    // 删除深造信息
    deleteEducation(index, rows) {
      var delInfo = this.ais_education[index]
      delInfo.delete_time = new Date().getTime() / 1000
      del_ais_education.push(delInfo)
      this.ais_education.splice(index, 1)
    },
    // 新增深造信息
    addEducation(index, info) {
      var userName = this.ais_info.name_cn
      this.$nextTick(() => {
        this.$refs._addEditEduDialog.show(index, userName, 'ais_education', info)
      })
    },
    // 编辑工作信息
    editJobInfo(index, info) {
      this.addJobInfo(index, info)
    },
    // 删除工作信息
    deleteJobInfo(index, rows) {
      var delInfo = this.ais_job_info[index]
      delInfo.delete_time = new Date().getTime() / 1000
      del_ais_job_info.push(delInfo)
      this.ais_job_info.splice(index, 1)
    },
    // 新增工作信息
    addJobInfo(index, info) {
      var userName = this.ais_info.name_cn
      this.$nextTick(() => {
        this.$refs._addEditJobDialog.show(index, userName, 'ais_job_info', info)
      })
    },
    // 编辑捐助信息
    editJournal(index, info) {
      this.addJournal(index, info)
    },
    // 删除捐助信息
    deleteJournal(index, rows) {
      var delInfo = this.ais_journal[index]
      delInfo.delete_time = new Date().getTime() / 1000
      del_ais_journal.push(delInfo)
      this.ais_journal.splice(index, 1)
    },
    // 新增捐助信息
    addJournal(index, info) {
      var userName = this.ais_info.name_cn
      this.$nextTick(() => {
        this.$refs._addEditJournalDialog.show(index, userName, 'ais_journal', info)
      })
    },
    // 编辑荣誉信息
    editHonor(index, info) {
      this.addHonor(index, info)
    },
    // 删除荣誉信息
    deleteHonor(index, rows) {
      var delInfo = this.ais_honor[index]
      delInfo.delete_time = new Date().getTime() / 1000
      del_ais_honor.push(delInfo)
      this.ais_honor.splice(index, 1)
    },
    // 新增荣誉信息
    addHonor(index, info) {
      var userName = this.ais_info.name_cn
      this.$nextTick(() => {
        this.$refs._addEditHonorDialog.show(index, userName, 'ais_honor', info)
      })
    },
    // 编辑或添加保存
    $toSaveEdit(index, type, info) {
      console.log(index)
      console.log(type)
      console.log(JSON.stringify(info))
      switch (type) {
        case 'ais_education': // 深造信息
          if (index == undefined) {
            this.ais_education.push(info)
          } else {
            this.ais_education[index] = info
          }
          break
        case 'ais_job_info': // 工作信息
          if (index == undefined) {
            this.ais_job_info.push(info)
          } else {
            this.ais_job_info[index] = info
          }
          break
        case 'ais_journal': // 捐助信息
          if (index == undefined) {
            this.ais_journal.push(info)
          } else {
            this.ais_journal[index] = info
          }
          break
        case 'ais_honor': // 荣誉信息
          if (index == undefined) {
            this.ais_honor.push(info)
          } else {
            this.ais_honor[index] = info
          }
          break
      }
    },
    // 操作日志
    toOpLog() {
      this.$refs._leftMeun.toOpLog()
    }
  }
}
</script>

<style lang="less" scoped>
.bor {
  display: block;
  border: 1px dashed #b1b1b1;
  border-radius: 4px;
  width: 100%;
  height: 22px;
  margin: 0 auto;
}
.increasedDiv {
  margin-top: 18px;
  margin-left: 21px;
  width: 1616px;
  height: 229px;
  background: #ffffff;
  border-radius: 4px;
  .basicInformation {
    float: left;
    width: 72px;
    height: 25px;
    margin-top: 12px;
    margin-left: 14px;
    .basicInformationText {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      color: #19233b;
    }
  }
  .grayLine {
    float: left;
    margin-top: 13px;
    width: 1615px;
    height: 1px;
    background: #e9eaec;
  }
  .allTittle {
    float: left;
    height: 38px;
    width: 1100px;
    .tittle {
      float: left;
      height: 38px;
      width: 20%;
      margin-top: 12px;

      .tittleText {
        font-family: PingFang SC;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #19233b;
      }
    }
  }
}
.header {
  width: 100%;
  height: 50px;
  background-color: #fff;
  border-radius: 5px;
}
.color_blue {
  color: #0096f9;
}
.header span {
  line-height: 50px;
  margin-right: 15px;
}
.header .left {
  float: left;
}
.header .right {
  float: right;
}
.mainTitle {
  width: 1600px;
}
.main div {
  background-color: #ffffff;
  border-radius: 5px;
}
.main_info {
  margin-top: 18px;
  margin-left: 21px;
  width: 1616px;
  height: 396px;
  background: #ffffff;
  border-radius: 4px;
  .basicInformation {
    float: left;
    width: 72px;
    height: 25px;
    margin-top: 12px;
    margin-left: 14px;
    .basicInformationText {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 25px;
      color: #19233b;
    }
  }

  .grayLine {
    float: left;
    margin-top: 13px;
    width: 1615px;
    height: 1px;
    background: #e9eaec;
  }
  .mainInfoLeft {
    float: left;
    height: 340px;
    width: 33%;
  }
  .mainInfoMiddle {
    float: left;
    height: 340px;
    width: 33%;
  }
  .mainInfoRight {
    float: left;
    height: 340px;
    width: 34%;
  }
  .mainInfoTittle {
    margin-top: 20px;
    margin-left: 12px;
    .mainInfoTittleText {
      float: left;
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #19233b;
    }
  }
  .mainInfoPhotoTittle {
    float: left;
    margin-top: 33px;
    margin-left: 135px;
    margin-bottom: 18px;
    .mainInfoPhotoTittleText {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 20px;
      color: #000000;
    }
  }
  .mainInfoPhoto {
    float: left;
    width: 160px;
    height: 220px;
    margin-top: 18px;
    background-color: #c4c4c4;
    border-radius: 0px;
  }
  .mainInfoBottom {
    float: left;
    height: 340px;
    width: 150px;
  }
}

.editAlumni {
  width: 96px;
  height: 34px;
  padding-left: 21px;
  padding-top: 7px;
  .editAlumniText {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 24px;
    line-height: 34px;
    color: #19233b;
  }
}
.editAlumniByHand {
  width: 84px;
  height: 20px;
  padding-left: 24px;
  padding-top: 13px;
  .editAlumniByHandText {
    font-family: PingFang SC;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    /* identical to box height */
    color: #7b7b7b;
  }
}
.foot {
  width: 100%;
  background-color: #ffffff;
  margin-top: 150px;
  padding-top: 10px;
  padding-right: 30px;
  padding-bottom: 10px;
  overflow: hidden;
}
.input_style {
  margin: 6px 0px 0px 16px;
  width: 95%;
}
.addData_style {
  font-size: 14px;
  line-height: 20px;
  color: #848484;
  font-family: PingFang SC;
  font-style: normal;
  font-weight: normal;
  // width: 127px !important;
  // height: 20px !important;
  margin-top: -12px;
  margin-left: 754px;
}
</style>




// WEBPACK FOOTER //
// src/pages/dataMgr/editInfo.vue